module.exports = __webpack_public_path__ + "static/media/ryo.29893fb5.svg";